import { css } from '@emotion/css'
import { spacing, fontSize, fontWeight, fontFamily, borderRadius, zIndex } from '../../styles'
import { shorthandHelper } from '../../styles/helpers'
import { colors } from '../../themes'

const styles = {
  wrapper: css({
    position: 'relative',
  }),

  body: css({
    color: colors.white,
    backgroundColor: colors.oxfordBlue,
    fontSize: fontSize.small,
    fontWeight: fontWeight.semiBold,
    fontFamily: fontFamily.body,
    lineHeight: 1.2,
    borderRadius: borderRadius.default,
    position: 'absolute',
    zIndex: zIndex.level7,
    width: 'max-content',
  }),
}

const positionModifier = position => {
  const distanceFromTrigger = `calc(100% + ${spacing.small}px)`

  switch (position) {
    case 'bottom':
      return css({
        top: distanceFromTrigger,
        right: '50%',
        transform: 'translateX(50%)',
      })

    case 'top':
      return css({
        bottom: distanceFromTrigger,
        right: '50%',
        transform: 'translateX(50%)',
      })

    case 'left':
      return css({
        right: distanceFromTrigger,
        bottom: '50%',
        transform: 'translateY(50%)',
      })

    case 'right':
      return css({
        left: distanceFromTrigger,
        bottom: '50%',
        transform: 'translateY(50%)',
      })

    case 'bottom-left':
      return css({
        top: distanceFromTrigger,
        left: 0,
      })

    case 'bottom-right':
      return css({
        top: distanceFromTrigger,
        right: 0,
      })

    case 'top-left':
      return css({
        bottom: distanceFromTrigger,
        left: 0,
      })

    case 'top-right':
      return css({
        bottom: distanceFromTrigger,
        right: 0,
      })

    case 'left-top':
      return css({
        right: distanceFromTrigger,
        top: 0,
      })

    case 'left-bottom':
      return css({
        right: distanceFromTrigger,
        bottom: 0,
      })

    case 'right-top':
      return css({
        left: distanceFromTrigger,
        top: 0,
      })

    case 'right-bottom':
      return css({
        left: distanceFromTrigger,
        bottom: 0,
      })

    default:
      return css()
  }
}

const sizeModifier = size => {
  switch (size) {
    case 'small':
      return css({
        padding: shorthandHelper([spacing.extraSmall, spacing.small]),
        maxWidth: 250,
      })

    default:
      return css({
        padding: shorthandHelper([spacing.small, spacing.default]),
        maxWidth: 350,
      })
  }
}

export default styles

export { positionModifier, sizeModifier }
